import {Poi} from '../../react-app-env';
import React, {ReactNode} from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {noop} from '../../utils/Utils';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';
import {PoiMetaData} from '../../services/MetaDataService';
import {StackApi} from '../stack/Stack.types';
import OpeningHoursSidebarPage from './openinghours/OpeningHoursSidebarPage';

export interface ScheduleGroupProps {
  poi: Poi;
  metaData: PoiMetaData | null;
  stackApi: StackApi;
}

const ScheduleGroup: React.FunctionComponent<ScheduleGroupProps> = ({ stackApi, poi, metaData }) => {

  function renderOpeningHours(): ReactNode {
    if (metaData?.openingHours.permanentlyClosed) {
      return <ListViewItem title={i18n().poiDetails.schedule.permanentlyClosed}
                           iconCategory="fa-clock fa-regular"/>;
    }

    if (metaData?.openingHours.temporarilyClosed) {
      return <ListViewItem title={i18n().poiDetails.schedule.temporarilyClosed}
                           iconCategory="fa-clock fa-regular"/>;
    }

    if (metaData?.openingHours.openNow === undefined) {
      return null;
    }

    const label = metaData?.openingHours.openNow
        ? i18n().poiDetails.schedule.currentlyOpen
        : i18n().poiDetails.schedule.currentlyClosed;

    const decoration = metaData?.openingHours.details
        ? DefaultItemDecorations.CHEVRON
        : undefined;

    const onClick = metaData?.openingHours.details
        ? () => stackApi.push({
          id:   'opening-hours--' + poi.id,
          nodeProvider: () => <OpeningHoursSidebarPage
                    poi={poi}
                    metaData={metaData}
                    stackApi={stackApi}/>
        })
        : noop;

    return <ListViewItem title={label}
                         iconCategory="fa-clock fa-regular"
                         decoration={decoration}
                         onClick={onClick}/>;
  }

  return <ListViewGroup>
    <ListViewItem title={poi.transit ?? i18n().poiDetails.schedule.describeTransit}
                  iconCategory="fa-arrows-split-up-and-left"
                  decoration={DefaultItemDecorations.EDIT}
                  onClick={() => noop()}/>
    <ListViewItem title={poi.duration ?? i18n().poiDetails.schedule.describeDuration}
                  iconCategory="fa-hourglass-half fa-regular"
                  decoration={DefaultItemDecorations.EDIT}
                  onClick={() => noop()}/>
    {renderOpeningHours()}
  </ListViewGroup>;
};

export default ScheduleGroup;
